module.exports = __webpack_public_path__ + "static/media/JQuery_Badge.31460728.png";